import { Component, OnInit, inject } from '@angular/core';
import { LegalAgreementsLibService } from 'src/app/services/libraries/legal-agreements-lib.service';
import { SessionLibService } from '@nutricontrol/app360-shared';
import { TranslationsLibService } from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-popup-cookies',
  templateUrl: './popup-cookies.component.html',
  styleUrls: ['./popup-cookies.component.scss'],
})
export class PopupCookiesComponent implements OnInit {
  translations = inject(TranslationsLibService);
  session = inject(SessionLibService);
  legalAgreementsLib = inject(LegalAgreementsLibService);

  showCookiePolicyPopup = false;

  constructor() {
    const session = this.session;

    this.showCookiePolicyPopup = session.getCookiesPolicy() !== 'true';
  }

  ngOnInit(): void {}

  acceptCookiesPolicy() {
    this.showCookiePolicyPopup = false;
    this.session.setCookiesPolicy('true');
  }
}
